import { ModuleWithProviders, NgModule } from "@angular/core";
import { AppInitializerService } from "./app-intializer/app-initializer.service";
import { CachingService, CRMActivityDataService, CRMActivityDefintionDataService, CRMContactDataService, CRMEntitySearchDataService, CRMFieldDataService, EntityConfigurationDataService, IndexdbCachingService, InMemoryCachingService, InviteMemberDataService, LocalStorageService, OrganisationDataService, OrganisationMemberDataService, UnsyncCachingService, UserDataService } from "./data";
import { UIService } from "./ui/ui.service";
import { AuthenticationService, IAMService } from "./auth";

@NgModule({
    imports: []
})

export class ServicesModule {
    constructor() { }
    static forRoot(): ModuleWithProviders<ServicesModule> {
        return {
            ngModule: ServicesModule,
            providers: [
                AppInitializerService,
                CachingService,
                InMemoryCachingService,
                UnsyncCachingService,
                IndexdbCachingService,
                UIService,
                LocalStorageService,
                AuthenticationService,
                IAMService,
                UserDataService,
                OrganisationDataService,
                OrganisationMemberDataService,
                CRMFieldDataService,
                CRMContactDataService,
                EntityConfigurationDataService,
                InviteMemberDataService,
                CRMActivityDefintionDataService,
                CRMActivityDataService,
                CRMEntitySearchDataService,
            ]
        };
    }
}
export {
    AppInitializerService,
    CachingService,
    InMemoryCachingService,
    UnsyncCachingService,
    IndexdbCachingService,
    UIService,
    LocalStorageService,
    AuthenticationService,
    IAMService,
    UserDataService,
    OrganisationDataService,
    OrganisationMemberDataService,
    CRMFieldDataService,
    CRMContactDataService,
    EntityConfigurationDataService,
    InviteMemberDataService,
    CRMActivityDefintionDataService,
    CRMActivityDataService,
    CRMEntitySearchDataService,
};